import { getAvatarUsers } from "services/get-avatar-users";

export const avatarUserSearch = async (phonenumber, minimumLength) => {
  if (phonenumber && phonenumber.length >= minimumLength) {
    const avatarUsers = await getAvatarUsers(phonenumber);

    return avatarUsers;
  }

  return false;
};
